
            const data = {"name":"plus","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M19 13a1 1 0 1 0 0-2h-6V5a1 1 0 1 0-2 0v6H5a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6Z\" _fill=\"#E53935\"/>","originalColors":[{"type":"fill","color":"#E53935"}],"stopColors":[]}}
        
                    module.exports = data
                    